import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { cn } from "styles/utils"

// size - lg: collection page; sm: PDP product recommendation
const ProductDescription = ({ productName, size = "lg" }) => {
  const holdbackExp = useSelector(
    (state) => state.experiment.holdback.variant_id
  )

  return (
    <p
      className={cn(
        "line-clamp-2 h-[calc(1.4em_*_2)] text-ellipsis",
        size === "lg"
          ? "desktop:line-clamp-1 desktop:h-[1.4em] body"
          : "body-sm",
        holdbackExp === 1 && size === "lg" ? "mb-10 mt-6 px-16" : "mb-8"
      )}
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
  size: PropTypes.string,
}

export default ProductDescription
